import { useState } from 'react';
import LayerTestBlock from './components/LayerTestBlock';

const LAYER_DEFS = [
  {
    layer: 1 as const,
    title: '基礎寄信（adm）',
    description:
      '驗證 send_qi_email 能把信寄到「任意信箱」，證明 Resend 串接與寄件網域已打通。成功收件後才進入第二層。',
    showNames: false,
    lockHint: '',
  },
  {
    layer: 2 as const,
    title: '施炁者通知 + 安全連結',
    description:
      '驗證信件裡的「安全連結按鈕」能開啟。貼上正式案例的安全連結可真正解析 token；用測試佔位連結則僅驗證寄信。成功且確認連結可開後才進入第三層。',
    showNames: true,
    lockHint: '請先完成第一層測試並確認收件。',
  },
  {
    layer: 3 as const,
    title: '通知內容 + 鏈條閉環',
    description:
      '驗證完整通知內容（主旨、按鈕、安全連結、隱私提醒）與 notify → send → 連結可開的閉環。通過後判定整條三層 Email 鏈完成。',
    showNames: true,
    lockHint: '請先完成第二層測試並確認安全連結可開啟。',
  },
];

export default function EmailTestPage() {
  const [completed, setCompleted] = useState<Record<number, boolean>>({ 1: false, 2: false, 3: false });

  const handleSuccess = (layer: number) => {
    setCompleted((prev) => ({ ...prev, [layer]: true }));
  };

  return (
    <div className="min-h-screen bg-background-50 pt-24 pb-16 px-4 md:px-6">
      <div className="max-w-2xl mx-auto space-y-6">
        <header className="space-y-2">
          <div className="flex items-center gap-2 flex-wrap">
            <h1 className="text-2xl font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              三層 Email 測試控制台
            </h1>
            <span className="whitespace-nowrap text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-900">TEST 工具</span>
          </div>
          <p className="text-sm text-foreground-600">
            依序測試第一層 → 第二層 → 第三層。任一层失敗請先停止，不要用下一層的成功掩蓋上一層的問題。
          </p>
        </header>

        <div className="rounded-lg border border-foreground-200/60 bg-background-100/60 px-4 py-3 text-xs text-foreground-600 space-y-1">
          <p className="font-medium text-foreground-800">測試安全規範</p>
          <p>• 不把任何真實測試信箱寫進前端，由你逐層輸入。</p>
          <p>• 三層皆為「純寄信」測試，不建立通知紀錄、不寫入正式資料表、不寄給正式使用者。</p>
          <p>• 不顯示 RESEND_API_KEY；安全連結檢查不會洩漏任何 Backend Secret。</p>
          <p>• 寄件者使用程式已設定的正式寄件地址（noreply@寄件網域）。</p>
        </div>

        {LAYER_DEFS.map((def) => {
          const enabled = def.layer === 1 || completed[def.layer - 1];
          return (
            <LayerTestBlock
              key={def.layer}
              layer={def.layer}
              title={def.title}
              description={def.description}
              showNames={def.showNames}
              enabled={enabled}
              lockHint={def.lockHint}
              onSuccess={() => handleSuccess(def.layer)}
            />
          );
        })}

        <div className="text-center text-xs text-foreground-400">
          {completed[1] && completed[2] && completed[3]
            ? '三層 Email 鏈已完成 ✅'
            : `進度：第一層 ${completed[1] ? '✅' : '⏳'} → 第二層 ${completed[2] ? '✅' : '⏳'} → 第三層 ${completed[3] ? '✅' : '⏳'}`}
        </div>
      </div>
    </div>
  );
}